import { useUpdateEffect } from 'ahooks';
import { useMemo, useState } from 'react';
export const useIndex = (props) => {
    const { setIndex, index } = props;
    const [value, setValue] = useState(index);
    const _setValue = useMemo(() => {
        return setIndex || setValue;
    }, [setIndex]);
    useUpdateEffect(() => {
        setValue(index);
    }, [index]);
    return {
        index: value,
        setIndex: _setValue,
    };
};
